const adminActionLogs = {
  title: '🔎 Admin action logs',
  filter_hint: 'Enter at least one filter (student/DNI, actor, or date range) to search',
  student_dni: 'Student DNI',
  table: 'Table',
  actor: 'Performed by',
  from: 'From',
  to: 'To',
  column: 'Field',
  old_value: 'Previous value',
  new_value: 'New value',
  operation: 'Operation',
  operation_insert: 'Created',
  operation_update: 'Updated',
  operation_delete: 'Deleted',
  source_unknown: 'Unknown source',
  source_retool: 'Retool',
  date: 'Date',
  no_results: 'No results for these filters',
  search_required: 'Enter at least one filter to search',
};

export default adminActionLogs;
